import api from './api'

const imaginaryCompanyBasePath = '/api/v1/user-imaginary-company'

export async function getAllImaginaryUserCompany() {
  const resp = await api.get(`${imaginaryCompanyBasePath}`)
  return resp.data
}

export async function getImaginaryUserCompanyById(imaginaryCompanyId) {
  const resp = await api.get(`${imaginaryCompanyBasePath}?id=${imaginaryCompanyId}`)
  return resp.data
}

export async function getImaginaryUserCompanyByUserId(userId) {
  const resp = await api.get(`${imaginaryCompanyBasePath}/${userId}`, userId)
  return resp.data
}

export async function saveImaginaryUserCompany(companyData, userId) {
  const resp = await api.post(`${imaginaryCompanyBasePath}`, { companyData: companyData, userId })
  return resp.data
}

export async function patchImaginaryUserCompanyById(imaginaryCompanyId, companyData) {
  const resp = await api.patch(`${imaginaryCompanyBasePath}/${imaginaryCompanyId}`, { companyData })
  return resp.data
}

export async function deleteImaginaryUserCompanyById(imaginaryCompanyId) {
  const resp = await api.delete(`${imaginaryCompanyBasePath}/${imaginaryCompanyId}`, imaginaryCompanyId)
  return resp.data
}
